import React from "react";
import { SymbolAvatar } from "@/components/common";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@/shadcn-components/ui/context-menu";
import { Info } from "lucide-react";
import {
  TradeOrder,
  VybeOrderType,
  formatOrderType,
  formatDealType,
  orderTypeBuySellClass,
} from "@/vybe-trader-client/trade-history/types";
import { formatHistoryLocalDateTime } from "@/components/history-view/historyDateTimeFormat";

interface PositionItemProps {
  position: TradeOrder;
  onClick?: () => void;
}

export default function PositionItem({ position, onClick }: PositionItemProps) {
  const isBalanceOperation =
    position.orderType === VybeOrderType.Balance ||
    position.orderType === VybeOrderType.Credit;

  // Użyj odpowiedniego formatowania typu
  const displayType = isBalanceOperation
    ? formatDealType(position.dealType)
    : formatOrderType(position.orderType);

  const closedAt = formatHistoryLocalDateTime(position.closeTime);

  const row = (
    <div
      className="flex items-center gap-3 py-2 border-b border-border cursor-pointer px-1"
      onClick={onClick}
    >
      <SymbolAvatar name={isBalanceOperation ? null : position.symbol} />
      <div className="min-w-0 flex-1">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          {isBalanceOperation ? (
            <span
              className={`font-medium ${
                position.profit >= 0 ? "text-blue-400" : "text-red-400"
              }`}
            >
              {displayType}
            </span>
          ) : (
            <>
              <span className="text-foreground font-medium">{position.symbol}</span>
              <span className="text-sm">
                <span className={orderTypeBuySellClass(position.orderType)}>
                  {displayType}
                </span>{" "}
                <span className="text-foreground">{position.lots}</span>
              </span>
            </>
          )}
        </div>
        {position.profit !== 0 && (
          <span
            className={position.profit >= 0 ? "text-blue-400" : "text-red-400"}
          >
            {position.profit > 0 ? "" : ""}
            {position.profit}
          </span>
        )}
      </div>
      <div className="flex items-center justify-between gap-2 text-muted-foreground text-xs">
        {isBalanceOperation ? (
          <span className="min-w-0 truncate">{position.comment || "Balance operation"}</span>
        ) : (
          <span className="min-w-0 truncate">
            {position.openPrice.toFixed(position.digits)} →{" "}
            {position.closePrice.toFixed(position.digits)}
          </span>
        )}
<span className="shrink-0 font-mono opacity-70">#{position.ticket}</span>
                <span className="shrink-0 text-right tabular-nums whitespace-nowrap">
          {closedAt}
        </span>
      </div>
      </div>
    </div>
  );

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{row}</ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuItem
          onSelect={() => {
            onClick?.();
          }}
        >
          <Info className="mr-2 h-4 w-4" />
          Show details
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
